import { render, staticRenderFns } from "./PaymentInfoWidget.vue?vue&type=template&id=08732681&scoped=true&lang=pug"
import script from "./PaymentInfoWidget.vue?vue&type=script&lang=js"
export * from "./PaymentInfoWidget.vue?vue&type=script&lang=js"
import style0 from "./PaymentInfoWidget.vue?vue&type=style&index=0&id=08732681&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08732681",
  null
  
)

export default component.exports